import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import TrainingProgramsCreateEditForm from './Components/TrainingProgramsCreateEditForm';
import TrainingProgramsApi from './TrainingProgramsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: TrainingProgramsCreateEditForm,
                getCreate: TrainingProgramsApi.create,
                getClone: TrainingProgramsApi.getOne,
                defaults: {
                    dataPoints: [],
                    dailyPrograms: [],
                    format: "dailyProgram",
                    starterGuide: [{ title: "PUT EXOGEN ON" }, { title: "LOAD UP" }, { title: "GO PLAY" }],
                },
                successMessage: "Training Programs Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}